import React, { useMemo } from "react";
import { resultToText } from "./results-per-package-table";
import InformationBox from "./information-box";
import ThreePartTableRow from "./three-part-table-row";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

const freqsTranslation = {
  LOW: "niskie",
  MEDIUM: "średnie",
  HIGH: "wysokie",
};
const SpeechAudiometryWithBands = ({ test }) => {
  const differentFrequencies = useMemo(
    () => [...new Set(test.data.resultsPerMarkers.map((el) => el.marker))],
    [test.data.resultsPerMarkers]
  );

  const resultsPerMarkers = useMemo(
    () => ({
      left: {
        low: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "LEFT" && el.marker === "LOW"
        )[0],
        medium: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "LEFT" && el.marker === "MEDIUM"
        )[0],
        high: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "LEFT" && el.marker === "HIGH"
        )[0],
      },
      right: {
        low: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "RIGHT" && el.marker === "LOW"
        )[0],
        medium: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "RIGHT" && el.marker === "MEDIUM"
        )[0],
        high: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "RIGHT" && el.marker === "HIGH"
        )[0],
      },
      both: {
        LOW: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "BOTH" && el.marker === "LOW"
        )[0],
        MEDIUM: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "BOTH" && el.marker === "MEDIUM"
        )[0],
        HIGH: test.data.resultsPerMarkers.filter(
          (el) => el.channel === "BOTH" && el.marker === "HIGH"
        )[0],
      },
    }),
    [test.data.resultsPerMarkers]
  );
  if (differentFrequencies.length) {
    return (
      <InformationBox headerText={"Wyniki szczegółowe dla pasm"}>
        <TableContainer
          style={{ maxWidth: 550, mb: 2, display: "inline-block" }}
        >
          {test.testType === "AS_MOB" && (
            <Table aria-label="simple table" size="small">
              <TableHead>
                <ThreePartTableRow
                  isHeader
                  rightText={"ucho lewe"}
                  middleText={"pasmo"}
                  leftText={"ucho prawe"}
                />
              </TableHead>
              <TableBody>
                {differentFrequencies.includes("LOW") && (
                  <ThreePartTableRow
                    rightText={`${resultToText(
                      resultsPerMarkers.left.low?.result
                    )} (${resultsPerMarkers.left.low?.correctPercent?.toFixed(
                      0
                    )}%)`}
                    middleText={"niskie"}
                    leftText={`${resultToText(
                      resultsPerMarkers.right.low?.result
                    )} (${resultsPerMarkers.right.low?.correctPercent?.toFixed(
                      0
                    )}%)`}
                  />
                )}

                {differentFrequencies.includes("MEDIUM") && (
                  <ThreePartTableRow
                    rightText={`${resultToText(
                      resultsPerMarkers.left.medium?.result
                    )} (${resultsPerMarkers.left.medium?.correctPercent?.toFixed(
                      0
                    )}%)`}
                    middleText={"średnie"}
                    leftText={`${resultToText(
                      resultsPerMarkers.right.medium?.result
                    )} (${resultsPerMarkers.right.medium?.correctPercent?.toFixed(
                      0
                    )}%)`}
                  />
                )}

                {differentFrequencies.includes("HIGH") && (
                  <ThreePartTableRow
                    rightText={`${resultToText(
                      resultsPerMarkers.left.high?.result
                    )} (${resultsPerMarkers.left.high?.correctPercent?.toFixed(
                      0
                    )}%)`}
                    middleText={"wysokie"}
                    leftText={`${resultToText(
                      resultsPerMarkers.right.high?.result
                    )} (${resultsPerMarkers.right.high?.correctPercent?.toFixed(
                      0
                    )}%)`}
                  />
                )}
              </TableBody>
            </Table>
          )}
          {test.testType === "TRMS_MOB" && (
            <Table aria-label="simple table" size="small">
              <TableBody>
                {differentFrequencies.map((freq) => (
                  <TableRow key={freq}>
                    <TableCell>
                      <Typography>{freqsTranslation[freq]}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{`${resultToText(
                        resultsPerMarkers.both[freq]?.result
                      )} (${resultsPerMarkers.both[
                        freq
                      ]?.correctPercent?.toFixed(0)}%)`}</Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </InformationBox>
    );
  }
};

export default SpeechAudiometryWithBands;
